import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Icon } from '@mdi/react';
import { mdiPlusOutline } from '@mdi/js';
import { Button, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import { FormattedMessage } from 'react-intl';
import { defineStyles } from '../../../theme';
import { useSTContext } from '../../SmartTableContext';
import { NewRowDialog } from '../../../components/NewRowDialog';
const styles = defineStyles({
    filterIconContainer: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        '& svg:nth-of-type(2)': {
            position: 'absolute',
            bottom: 0,
            left: 16,
        },
    },
});
export const NewRowButton = ({ allowNewColumns }) => {
    const [open, setOpen] = useState(false);
    const table = useSTContext();
    const editableVisibleColumns = useMemo(() => table.visibleColumns.filter((i) => i.insertable), [table.visibleColumns]);
    const disabled = table.columnsError;
    return (_jsxs(_Fragment, { children: [disabled ? (_jsx(Tooltip, { title: _jsx(FormattedMessage, { id: "newRow.disabled.tooltip", defaultMessage: "Batch edit cannot be used on an empty table. Upload the data via the upload button (CSV)" }), children: _jsx("span", { children: _jsx(Button, { size: "small", variant: "outlined", disabled: true, onClick: () => setOpen(true), startIcon: _jsx(Box, { sx: styles.filterIconContainer, children: _jsx(Icon, { path: mdiPlusOutline, size: 1 }) }), children: _jsx(FormattedMessage, { id: "table.newRow.button", defaultMessage: "Add" }) }) }) })) : (_jsx(Button, { size: "small", variant: "outlined", onClick: () => setOpen(true), startIcon: _jsx(Box, { sx: styles.filterIconContainer, children: _jsx(Icon, { path: mdiPlusOutline, size: 1 }) }), children: _jsx(FormattedMessage, { id: "table.newRow.button", defaultMessage: "Add" }) })), _jsx(NewRowDialog, { open: open, invalidateTable: table.invalidateTable, onClose: () => setOpen(false), visibleColumns: editableVisibleColumns, addRowApiCall: table.api.addRowApiCall, allowNewColumns: allowNewColumns, renderExtraContent: table.renderExtraContent })] }));
};
//# sourceMappingURL=NewRowButton.js.map